<template>
  <div class="row mb5">
    <div class="col-md-6">
      <canvas :id="'comprice'"></canvas>
    </div>
  </div>
</template>
<script>
import { Line } from "vue-chartjs";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: {},
  extends: Line,
  mixins: [commonMixins],
  props: ["groupData", "groupLabels", "comPriceData"],
  data() {
    return {
      graphOptions: {
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      }
    };
  },
  created() {
    // console.log(this.chartData);
    this.configureChart();
  },
  methods: {
    plot() {
      this.configureChart();
    },
    configureChart() {
      this.graphOptions["plugins"] = {
        datalabels: {
          display: false,
          align: "top",
          anchor: "end"
        }
      };
      var ctx = document.getElementById("comprice").getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.groupLabels,
          datasets: [
            {
              label: "",
              backgroundColor: "transparent",
              borderColor: "#ef5350",
              pointBackgroundColor: "#ffffff",
              data: this.groupData //.slice(0, 100)
            },
            {
              label: "",
              backgroundColor: "rgba(230,240,244,.5)",
              borderColor: "#5c6bc0",
              pointBackgroundColor: "#ffffff",
              data: this.comPriceData //.slice(0, 100)
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
    }
  },
  mounted() {
    console.log("Mounted", this.chartData);
    // if (this.chartData.length > 0) this.configureChart();
  }
};
</script>



// WEBPACK FOOTER //
// src/views/indices-data/groupVsComp.vue